import { tv } from 'tailwind-variants';

export const defaultVariants = tv({
  slots: {
    base: [],
    heading: ['heading-2', 'text-textPrimary'],
  },
});

export const stickyTileVariants = tv({
  slots: {
    tileWrapper: ['flex-1', 'p-2'],
    tileLink: [
      'flex',
      'flex-col',
      'grow',
      'items-center',
      'justify-center',
      'text-sm leading-4',
      'sm:text-[16px]',
      'hover:underline',
      'h-full',
    ],
    tileLabel: ['font-medium', 'tracking-normal', 'text-center'],
  },
});

export const stickyTilesVariants = tv({
  slots: {
    container: [
      'sticky',
      'flex',
      'xm:hidden',
      'bottom-0',
      'z-10001',
      'divide-x-[3px]',
      'divide-solid',
      'divide-white',
    ],
  },
});

export const stickyTileModalVariants = tv({
  slots: {
    tileWrapper: ['flex-1', 'p-2'],
    tileButton: [
      'flex',
      'flex-col',
      'grow',
      'items-center justify-center',
      'w-full',
      'text-sm leading-4',
      'sm:text-[16px]',
      'cursor-pointer',
      'h-full',
    ],
    tileLabel: ['font-medium', 'tracking-normal text-center'],
    modalSubmit: ['w-full px-3 py-1.5 min-w-auto min-h-fit text-[16px] leading-normal'],
    modalBody: ['flex', 'flex-col'],
    modalTitle: ['text-nav-primary', 'font-bold', 'text-[1.5rem]', 'leading-normal', 'mb-2'],
    modalForm: ['py-[16px]', 'border-t-2', 'border-t-[#e3e3e3]', 'flex', 'flex-col', 'gap-[16px]', 'mb-2'],
    modalInput: ['border', 'px-[12px]', 'py-[6px]', 'rounded', 'text-[#495057]', 'font-medium', 'border-[#495057]!'],
    modalActions: ['w-full', 'grid', 'grid-cols-2', 'gap-7.5'],
    modalForgotLink: [
      'text-nav-secondary',
      'text-[16px]',
      'font-medium',
      'leading-normal',
      'underline',
    ],
    modalDisclaimer: [
      'mt-[16px]',
      '**:text-[16px]',
      '**:font-semibold',
      '**:leading-6',
      '[&_p]:text-[#6b6b6b]',
      'border-b-2',
      'border-b-[#e3e3e3]',
    ],
    modalSignUp: [
      '[&_p]:mb-0',
      'mt-[16px]',
      '**:text-[16px]',
      '**:font-semibold',
      '**:leading-6',
      '[&_p]:text-[#6b6b6b]',
      '[&_a]:text-nav-secondary',
    ],
  },
});
